<template>
  <div class="customer-profile-wrapper">
    <!-- customer-profile display -->
    <div class="customer-profile-container" v-animate-css="'fadeIn'">
      <div class="customer-profile-header">
        <label class="title">Public information</label>
        <div class="customer-profile-brand">
          <img v-if="getCustomer.company_image" :src="$fullUrl('images/profiles/' + getCustomer.company_image)" />
          <img v-else src="@/assets/icons/logo_avatar.svg" alt />
          <span>{{ getCustomer.name | validate }}</span>
          <span>{{ getCustomer.address | validate }}</span>
          <span>{{ getCustomer.phone | validate }}
            <span class="sep" v-if="getCustomer.phone && getCustomer.email">|</span>
            {{ getCustomer.email | validate }}</span>
          <p v-html="getCustomer.description"></p>
          <div class="customer-profile-option">
            <a class="go-to-read-btn" href="/lia">Go to LIA</a>
            <button class="edit-btn" @click.prevent="$router.push({ name: 'customer-settings' })">
              Edit Profile
            </button>
          </div>
        </div>
        <div class="customer-profile-options"></div>
      </div>
      <div class="customer-profile-body">
        <ul class="assignments-items" v-if="internship_data.length > 0">
          <li class="assignments-starter">
            <div class="assignments-item-header">
              <label>LIA</label>
            </div>
          </li>

          <li class="assignments-item" v-for="(item, index) in internship_data" :key="index">
            <div class="assignments-item-header">
              <div class="assignments-item-brand">
                <img v-if="item.owner.customer_profile.logo" :src="$fullUrl(
                  'images/profiles/' + item.owner.customer_profile.logo
                )
                  " />
                <img v-else src="@/assets/icons/logo_avatar.svg" />
              </div>
              <div class="content">
                <div class="title-row">
                  <label class="assignment-title">{{ item.name }}</label>
                  <label class="assignment-company">{{
                    item.owner.customer_profile.name
                  }}</label>
                  <span class="address-loaction"><img width="10" src="@/assets/icons/green-map-marker.svg" />
                    {{ item.owner.customer_profile.address }}</span>

                  <button class="btn-description">
                    Description
                    <img v-if="false" src="@/assets/icons/blue-caret-down.svg" />
                    <img v-else src="@/assets/icons/blue-caret-up.svg" />
                  </button>
                </div>
              </div>
              <div class="assignment-options"></div>
            </div>
            <div class="assignments-item-body">
              <div class="assignments-info">
                <p class="assignment-desc">
                  {{ item.description }}
                </p>
              </div>
            </div>
          </li>
        </ul>
        <div class="empty-widget" v-else>
          <div class="empty-widget-body">
            <p>You don't have any published internship</p>
          </div>
        </div>
      </div>
    </div>
    <!-- End -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
export default {
  name: "genelar-info-profile",
  components: {},
  props: {},
  data: () => {
    return {
      internship_data: [],
    };
  },
  mounted() {
    let vm = this;
    vm.$store.dispatch("GET_CUSTOMER");
    vm.getPublicInternship();
  },
  computed: {
    ...mapGetters(["getCustomer"]),
  },
  methods: {
    getPublicInternship() {
      let vm = this;
      vm.$store
        .dispatch("CUSTOMER_GET_PUBLIC_INTERNSHIP")
        .then((response) => {
          vm.internship_data = response.data;
        })
        .catch((error) => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-profile-wrapper {
  padding-top: 10px;
  width: 800px;

  @media (min-width: 300px) and (max-width: 630px) {
    padding-top: 0px;
    width: 100%;
  }

  .customer-profile-container {
    padding: 1px;

    .customer-profile-header {
      padding: 20px;
      border-radius: 5px;
      background: #ffffff;
      margin-bottom: 10px;

      @media (min-width: 300px) and (max-width: 630px) {
        border-radius: 0px;
      }

      .title {
        font-size: 16px !important;
        margin-bottom: 16px;
        display: none;

        @media (min-width: 300px) and (max-width: 630px) {
          display: block;
        }
      }

      .customer-profile-brand {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        @media (min-width: 300px) and (max-width: 630px) {
          border: 1px solid #ddd;
          padding: 20px;
          border-radius: 4px;
        }

        img {
          width: 60px;
          height: 60px;
          object-fit: cover;
          margin-bottom: 10px;
          border-radius: 50%;
        }

        span {
          font-size: 14px;
          margin-bottom: 10px;
        }

        p {
          font-size: 14px;
          line-height: 20px;

          margin: 10px 50px 10px 50px;

          @media (min-width: 300px) and (max-width: 630px) {
            margin: 10px 0px 10px 0px;
            text-align: justify;
          }
        }

        .customer-profile-option {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;

          .go-to-read-btn {
            background: #1885ad 0% 0% no-repeat padding-box;
            border-radius: 5px;
            padding: 10px 18px;
            font-size: 14px;
            margin-top: 13px;
            color: #fff;
            cursor: pointer;
            outline: none;
            width: 200px;
            margin-right: 20px;

            text-decoration: none;
            text-align: center;

            @media (min-width: 300px) and (max-width: 630px) {
              font-size: 13px;
            }
          }

          .edit-btn {
            background: #ffffff 0% 0% no-repeat padding-box;
            border: 1 solid #ddd;
            border-radius: 5px;
            padding: 10px 18px;
            font-size: 14px;
            margin-top: 13px;
            color: #646262;
            cursor: pointer;
            outline: none;
            width: 130px;

            border: 1px solid #ccc;

            @media (min-width: 300px) and (max-width: 630px) {
              font-size: 13px;
            }
          }
        }
      }

      .customer-profile-options {
        .btn-edit-info {
          border: 1px solid #36adae;
          border-radius: 5px;
          color: #1885ad;
          padding: 10px 50px;
        }
      }
    }

    .customer-profile-body {
      padding: 20px;
      border-radius: 5px;
      background: #ffffff;

      ul.assignments-items {
        padding: 0px 10px;
        list-style: none;

        .assignments-starter {
          margin-bottom: 6px;

          .assignments-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0px 0px;

            label {
              color: #000000;

              font-size: 16px;
            }

            .btn-add-assignment {
              color: #1ba5a4;
              border: none;
              padding: 10px 10px;
              font-size: 14px;
              outline: none;
              cursor: pointer;

              font-style: italic;
              background: transparent;
            }
          }

          .assignments-item-search {
            margin-bottom: 25px;

            .search-add-btn-widget {
              display: grid;
              grid-template-columns: 100%;
              grid-column-gap: 20px;

              .search-widget {
                border: 1px solid #ccc;
                height: 45px;
                display: flex;
                align-items: center;
                padding: 0px 10px;
                border-radius: 5px;

                img {
                  width: 25px;
                  height: 25px;
                }

                input {
                  height: 42px;
                  width: 100%;
                  padding-left: 15px;
                  outline: none;
                  border: none;
                }
              }

              .add-btn {
                width: 191px;
                height: 45px;
                background: #1885ad 0% 0% no-repeat padding-box;
                border-radius: 5px;
                opacity: 1;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                  margin-left: 10px;
                }
              }
            }
          }

          p {
            color: #131313;
          }
        }

        .assignments-item {
          background: #ffffff;
          border-radius: 5px;
          margin-bottom: 10px;
          position: relative;
          padding: 0px 0px;
          border: 1px solid rgb(223, 223, 223);

          @media (min-width: 300px) and (max-width: 630px) {
            padding: 0px 0px;
          }

          .assignments-item-header {
            display: flex;
            padding: 10px 14px;

            .assignments-item-brand {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 60px;
              height: 60px;

              @media (min-width: 300px) and (max-width: 630px) {
                width: 60px;
                height: 60px;
              }

              img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                object-fit: cover;

                @media (min-width: 300px) and (max-width: 630px) {
                  width: 50px;
                  height: 50px;
                }
              }
            }

            .content {
              display: flex;
              width: 62%;
              padding-right: 5px;
              padding-left: 10px;
              justify-content: space-between;
              align-items: flex-start;
              padding-top: 6px;

              .title-row {
                width: 100%;

                .assignment-title {
                  font-size: 18px;

                  margin-bottom: 1px;
                  color: #000;
                  margin-bottom: 5px;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 93%;
                  display: block;
                }

                .assignment-company {
                  font-size: 16px;

                  margin-bottom: 1px;
                  color: rgb(24, 24, 24);
                  margin-bottom: 5px;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 93%;
                  display: block;
                }

                .address-loaction {
                  color: #1ba5a4;
                  margin-bottom: 5px;
                  font-size: 14px;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 93%;
                  display: block;
                }

                span.date {
                  color: #808080;

                  font-size: 13px;
                  margin-bottom: 2px;
                  display: block;
                  margin-bottom: 5px;
                }

                .btn-description {
                  color: #0884af;
                  margin-left: 0px;
                  margin-top: 4px;
                  font-size: 14px;
                  display: flex;
                  align-items: center;

                  img {
                    width: 12px;
                    margin-left: 6px;
                  }
                }
              }

              .options {
                display: flex;
                align-items: flex-end;
                flex-direction: column;

                .date {
                  color: #808080;

                  font-size: 13px;
                  display: flex;
                  justify-content: flex-end;
                  width: 188px;
                  align-items: center;

                  .separator {
                    margin: 0px 5px;
                  }

                  @media (min-width: 300px) and (max-width: 630px) {
                    font-size: 11px;
                    width: 145px;
                  }
                }

                .status {
                  color: #000;

                  font-size: 13px;
                }

                .publish-btn,
                .un-publish-btn {
                  border: 1px solid #2f90b6;
                  border-radius: 5px;
                  padding: 6px 20px;
                  color: #2f90b6;
                  background: transparent;
                  cursor: pointer;
                }
              }
            }

            .assignment-options {
              display: flex;
              justify-content: flex-end;
              width: 30%;

              .btn-published {
                background: transparent;
                height: 40px;
                width: 125px;
                border-radius: 5px;
                color: #1ba5a4;
                font-style: italic;
                cursor: auto;
              }
            }

            .toogle-panel-btn {
              padding: 1px 7px;
              font-size: 16px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
              position: absolute;
              bottom: 10px;
              right: 5px;
              height: 15px;
            }
          }

          .assignments-item-body {
            padding-left: 85px;
            padding-right: 20px;
            padding-bottom: 15px;

            .assignments-info {
              .assignment-desc {
                color: #707070;
                margin-bottom: 11px;
              }
            }

            .divider-line-widget {
              display: flex;
              align-items: center;

              .line {
                width: 100%;
                border-bottom: 1px solid #ddd;
              }

              .btn-toogle {
                margin-left: 10px;
              }
            }
          }

          .assignment-footer {
            padding-left: 85px;
            padding-right: 20px;
            padding-bottom: 15px;

            h3 {
              font-size: 18px;
              margin-bottom: 10px;
            }

            .student-widget {
              .student-tabs {
                display: flex;
                margin-bottom: 7px;

                .student-tab {
                  height: 30px;
                  display: flex;
                  align-items: center;
                  padding: 0px 40px;
                  cursor: pointer;

                  &.active {
                    border-bottom: 3px solid #1ba5a4;
                  }
                }
              }

              .student-tab-body {
                height: 300px;

                table {
                  border-collapse: collapse;

                  tr {
                    cursor: pointer;

                    &.active {
                      border: 1px solid #1ba5a4;
                      border-radius: 5px;
                    }

                    th {
                      width: 200px;
                      padding: 10px;
                      color: #9f9f9f;
                    }

                    td {
                      padding: 10px;
                      position: relative;

                      .student-profile-widget {
                        display: flex;
                        align-items: center;

                        img {
                          width: 30px;
                          height: 30px;
                          border-radius: 50%;
                          margin-right: 10px;
                        }

                        label {
                          margin: 0px;
                        }
                      }

                      .school-profile-widget {
                        display: flex;
                        align-items: center;

                        img {
                          width: 30px;
                          height: 30px;
                          border-radius: 50%;
                          margin-right: 10px;
                        }

                        label {
                          margin: 0px;
                        }
                      }

                      .student-modal-widget {
                        position: absolute;
                        bottom: 10px;
                        left: 0px;
                        height: 550px;
                        width: 350px;
                        background: #fff;
                        box-shadow: -4px -2px 4px rgba(0, 0, 0, 0.25);
                        border-radius: 10px;
                        border: 2px solid #1ba5a4;
                        z-index: 9999;
                        padding: 10px;

                        .student-modal-widget-header {
                          display: flex;
                          justify-content: space-between;
                          margin-bottom: 20px;
                          height: 40px;

                          .student-profile-info {
                            display: flex;

                            img {
                              height: 40px;
                              height: 40px;
                              border-radius: 50%;
                              margin-right: 10px;
                            }

                            .information {
                              display: flex;
                              flex-direction: column;
                            }
                          }
                        }

                        .student-modal-widget-body {
                          overflow-y: auto;
                          height: calc(100% - 60px);

                          .description-widget {
                            label {
                              display: block;
                              margin-bottom: 10px;
                              font-size: 16px;
                            }

                            p {
                              font-size: 14px;
                              color: #707070;
                            }
                          }

                          .skills-widget {
                            .skills_content__wrapper {
                              display: grid;
                              grid-template-columns: 1fr 1fr;
                              grid-column-gap: 10px;
                              margin-bottom: 10px;

                              @media (min-width: 300px) and (max-width: 630px) {
                                grid-template-columns: 1fr;
                              }

                              .skill_box {
                                min-width: 0;
                                display: flex;
                                flex-direction: column;
                                width: 100%;
                                background: #fff;
                                border-radius: 5px;
                                margin-bottom: 15px;

                                .skill_box_header {
                                  border-bottom: 2px solid #f5f5f5;
                                  height: 50px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: space-around;
                                  padding: 0px 15px;

                                  label {
                                    color: #0884af;
                                    width: 100%;
                                    font-size: 15px;
                                    font-weight: 800;
                                  }
                                }

                                .skill_box_body {
                                  padding: 0px 15px;

                                  .empty-skills {
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    height: 200px;
                                    justify-content: center;

                                    p {
                                      text-align: center;
                                      margin-bottom: 20px;
                                      color: #8d8d8d;
                                    }

                                    button {
                                      width: 133px;
                                      height: 36px;
                                      background: #1890a9 0% 0% no-repeat padding-box;
                                      border-radius: 5px;
                                      color: #fff;
                                    }
                                  }

                                  .row__item {
                                    margin-top: 10px;
                                    display: flex;
                                    margin-bottom: 10px;
                                    justify-content: space-between;
                                    width: 100%;

                                    span {
                                      color: #000000;
                                      font-weight: normal;
                                      margin-top: 2px;
                                      font-size: 14px;
                                      font-weight: 800;
                                    }
                                  }
                                }
                              }
                            }

                            .next_skills_content__wrapper {
                              display: grid;
                              grid-template-columns: 1fr 1fr;
                              grid-column-gap: 10px;

                              @media (min-width: 300px) and (max-width: 630px) {
                                grid-template-columns: 1fr;
                              }

                              .skill_box {
                                min-width: 0;
                                display: flex;
                                flex-direction: column;
                                width: 100%;
                                background: #fff;
                                border-radius: 5px;
                                margin-bottom: 15px;

                                .skill_box_header {
                                  border-bottom: 2px solid #f5f5f5;
                                  height: 50px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: space-around;
                                  padding: 0px 15px;

                                  label {
                                    color: #0884af;
                                    width: 100%;
                                    font-size: 15px;
                                    font-weight: 800;
                                  }
                                }

                                .skill_box_body {
                                  padding: 0px 15px;

                                  .empty-skills {
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    height: 200px;
                                    justify-content: center;

                                    p {
                                      text-align: center;
                                      margin-bottom: 20px;
                                      color: #8d8d8d;
                                    }

                                    button {
                                      width: 133px;
                                      height: 36px;
                                      background: #1890a9 0% 0% no-repeat padding-box;
                                      border-radius: 5px;
                                      color: #fff;
                                    }
                                  }

                                  .row__item {
                                    margin-top: 10px;
                                    display: flex;
                                    margin-bottom: 10px;
                                    justify-content: space-between;
                                    width: 100%;

                                    span {
                                      color: #000000;
                                      font-weight: normal;
                                      margin-top: 2px;
                                      font-size: 14px;
                                      font-weight: 800;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      .empty-widget {
        background: #fff;
        padding: 20px;

        .empty-widget-body {
          height: 350px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          p {
            text-align: center;
            width: 270px;
          }

          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }
    }
  }

  .information-container {
    background: #f5f5f5 0% 0% no-repeat padding-box;
    border-radius: 5px;
    padding: 40px;

    .information-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;

      .information-brand {
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          width: 100px;
          margin-right: 20px;
        }

        span {}
      }

      .information-options {
        .btn-edit-info {
          box-shadow: 0px 1px 3px #00000029;
          border: 1px solid #36adae;
          border-radius: 5px;
          color: #1885ad;
          padding: 10px 50px;
        }
      }
    }

    .information-body {
      padding: 20px;

      ul {
        margin-left: -38px;
        list-style: none;

        .information-item {
          margin-bottom: 30px;

          label {
            color: #808080;
          }

          p {
            color: #131313;
          }
        }
      }
    }
  }
}

.input-flex {
  display: flex;
}</style>